var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIExcelFile = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 0C3.7875 0 3 0.759375 3 1.6875V25.3125C3 26.2406 3.7875 27 4.75 27H22.25C23.2125 27 24 26.2406 24 25.3125V6.75L17 0H4.75Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9375 6.75H24L17.25 0V5.0625C17.25 5.99062 18.0094 6.75 18.9375 6.75Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 12L18.75 6.75H24V12Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 21.6875C21 22.1344 20.6063 22.5 20.125 22.5H0.875C0.39375 22.5 0 22.1344 0 21.6875V13.5625C0 13.1156 0.39375 12.75 0.875 12.75H20.125C20.6063 12.75 21 13.1156 21 13.5625V21.6875Z",
    fill: "#84BD5A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.88415 16.9245L7.09165 15.3994C7.45278 14.9234 8.15419 15.5315 7.75834 15.9865C7.34253 16.4835 6.90501 17.0225 6.48833 17.5746L7.90418 19.3518C8.28614 19.8768 7.52309 20.3799 7.14808 19.8619L5.87026 18.2108L4.61414 19.8978C4.25996 20.4079 3.47521 19.8348 3.87106 19.3588L5.26607 17.5746C4.82856 17.0216 4.40493 16.4835 3.98217 15.9865C3.54553 15.4615 4.35718 14.9234 4.67664 15.4143L5.88415 16.9245Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76099 15.6645C8.76099 15.4335 8.95544 15.2375 9.1985 15.2375C9.42073 15.2375 9.60824 15.4344 9.60824 15.6645V19.1698H11.4963C12.176 19.1698 12.1908 20.0859 11.4963 20.0859H9.19937C8.95631 20.0859 8.76185 19.9118 8.76185 19.6598V15.6645H8.76099Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8123 16.2945C12.972 14.9365 15.0051 14.6924 15.9634 15.4344C16.4357 15.8185 15.9357 16.4275 15.519 16.1195C15.0051 15.7914 13.8392 15.6374 13.6934 16.3636C13.5059 17.5116 16.5251 16.8545 16.4765 18.7156C16.4279 20.4928 13.874 20.5339 12.9156 19.7368C12.6855 19.5478 12.6934 19.2406 12.8184 19.0508C12.9989 18.8696 13.1995 18.8066 13.4364 19.0026C14.005 19.3938 15.4704 19.6878 15.5737 18.6938C15.4843 17.6595 12.597 18.2816 12.8123 16.2945Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1375 22.875H3.75V24H20.1375C20.6119 24 21 23.4937 21 22.875V21.75C21 22.3687 20.6119 22.875 20.1375 22.875Z",
    fill: "#CAD1D8"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIExcelFile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/i_excel_file.f64c484e.svg";
export { ForwardRef as ReactComponent };